export default __webpack_public_path__ + "static/media/lotti-seriali-dark.ce3e5a78.svg";